import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { peerToPeerReport } from 'app/manage-p2p/features/p2p.actions';
import { ModalFullfillAllDonorsService } from 'app/manage-p2p/services/modal-fullfill-all-donors/modal-fullfill-all-donors.service';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { ToastService } from 'app/toast/services/toast.service';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-p2p-fulfill-all-donors-modal',
  standalone: true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,NgxPaginationModule],
  templateUrl: './p2p-fulfill-all-donors-modal.component.html',
  styleUrl: './p2p-fulfill-all-donors-modal.component.scss'
})
export class P2pFulfillAllDonorsModalComponent  implements OnInit {
  destroyRef = inject(DestroyRef)

  @Input () data

  public isFulfillActive = true;
  public milestonesAchived = null;
  public milestonesAchivedError = false;
  public milestonesAchivedErrorText = '';
  public p: number = 1;
  public filteredPledges = [];
  public pledgesAmount = 0;

  constructor(
    private modalFullfillAllDonorsService: ModalFullfillAllDonorsService,
    private peerToPeerManageService: PeerToPeerManageService,
    private store: Store,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    if(this.data.pledges){
      this.filteredPledges = this.data.pledges.filter((pledge)=>pledge.status == 0)
    }
    
    if (this.data.eventCount > 0) {
      this.milestonesAchived = this.data.eventCount;
      this.onMilestonesAchivedChange();
    }

    if( this.filteredPledges.length === 0 ){
      this.isFulfillActive = false
    }
  }


  close() {
    this.modalFullfillAllDonorsService.close();
  }


  onInputFocus() {
    this.milestonesAchivedError = false;
  }

  fulfill(){
    const maxEventCount = this.data.campaignData.campaignTypeData.maxEventCount;
    
    if (!this.milestonesAchived || this.milestonesAchived < 1 || this.milestonesAchived > maxEventCount) {
      this.milestonesAchivedErrorText = `Please provide Milestones from 1 to ${maxEventCount}`
      this.milestonesAchivedError = true;
      return
    }

    const params = {
      eventCount: this.milestonesAchived,
      p2PId: this.data.id
    }
  
    this.peerToPeerManageService.fulfillAllDonors(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(()=>{
      this.store.dispatch({
        type: peerToPeerReport.type,
        payload: this.data.campaignId
      });

      this.toastService.show('success', 'All pending pledges fulfilled successfully!', {delay: 2000});
      this.close();
    });

  }

  onMilestonesAchivedChange(){
    let allPledgesAmount = 0;
    this.filteredPledges = this.filteredPledges.map((pledge)=>{
      pledge.amountCharged = pledge.amount * this.milestonesAchived;
      allPledgesAmount += pledge.amountCharged;
      return pledge
    })
    this.pledgesAmount = allPledgesAmount;
  }
}
